import React from 'react';

import { Paper } from '@mui/material';

import MessagePreamble from './MessagePreamble';
import PreviewPanels from './panels';

type Props = {
  waypointEventId: string;
};
export default function WaypointEventBody({ waypointEventId }: Props) {
  return (
    <Paper>
      <MessagePreamble waypointEventId={waypointEventId} />
      <PreviewPanels waypointEventId={waypointEventId} />
    </Paper>
  );
}
